import { env } from '@/lib/env';

let pending = 0;
const PENDING_TTL = 8000;

/**
 * [Client] 调用 /api/concurrency/check 检查当前用户是否超出并发限制。
 * 在 handle-generate 中发起生成请求前调用。
 * 用 pending 计数器防止快速连点绕过检查（DB 记录还没落库的窗口期）。
 * 超限时弹出专属弹窗并返回 false；检查接口自身异常时 fail-open。
 *
 * @param projectId 当前项目 ID，用于按项目归属决定是否走团队并发限额。
 */
export async function checkConcurrency(projectId: string): Promise<boolean> {
  if (env.NEXT_PUBLIC_SKIP_CONCURRENCY_CHECK === 'true') return true;
  let data: { allowed: boolean; current: number; limit: number };
  try {
    const res = await fetch(`/api/concurrency/check?projectId=${encodeURIComponent(projectId)}`, {
      headers: { 'x-internal-secret': env.NEXT_PUBLIC_INTERNAL_API_SECRET },
    });
    if (!res.ok) return true;
    data = await res.json();
  } catch {
    return true;
  }
  const effectiveCurrent = data.current + pending;
  if (!data.allowed || effectiveCurrent >= data.limit) {
    window.dispatchEvent(new CustomEvent('open_concurrency_limit', {
      detail: { current: effectiveCurrent, limit: data.limit },
    }));
    return false;
  }
  pending++;
  setTimeout(() => { pending = Math.max(0, pending - 1); }, PENDING_TTL);
  return true;
}
